import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

//import { Tab1Root } from '../pages';
//import { Tab2Root } from '../pages';
//import { Tab3Root } from '../pages';
//import { Tab4Root } from '../pages';

@IonicPage({
  name: 'tab',
  segment: 'novopsych'
})
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html'
})

//@ViewChild('myTabs') tabRef: Tabs;
export class TabsPage {
  
  activeTab: any;

  tab1Root: string = 'home';
  tab2Root: string = 'clients';
  tab3Root: string = 'assessments';
  tab4Root: string = 'account';

  tab1Title = " ";
  tab2Title = " ";
  tab3Title = " ";
  tab4Title = " ";

  constructor(public navCtrl: NavController, public translateService: TranslateService, public navParams: NavParams) {
    translateService.get(['TAB1_TITLE', 'TAB2_TITLE', 'TAB3_TITLE','TAB4_TITLE']).subscribe(values => {
      this.tab1Title = values['TAB1_TITLE'];
      this.tab2Title = values['TAB2_TITLE'];
      this.tab3Title = values['TAB3_TITLE'];
      this.tab4Title = values['TAB4_TITLE'];
    });
    this.activeTab = this.navParams.get("tab")?this.navParams.get("tab"):0
  }

  // ionViewDidEnter() {
  //   this.tabRef.select(2);
  //  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts